<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table
      :headers="headers"
      :items="visit_type_super_master_list"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Visit Type</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on"
                >Add Visit Type
              </v-btn>
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.name"
                          persistent-hint
                          :hint="
                            editedIndex == -1
                              ? 'For example :: Walk-In, Pre-Approved, ID-Card'
                              : 'For example :: Walk-In, Pre-Approved, ID-Card'
                          "
                          label="Enter Visit Type"
                          :rules="[(v) => !!v || 'required']"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          dense
                          v-model="editedItem.isactive"
                          color="success"
                          label="Active"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="primary darken-1"
                    @click="save"
                    :disabled="!valid"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.isactive="{ item }">
        <v-switch
          inset
          v-model="item.isactive"
          :color="item.isactive ? 'success' : 'primary'"
          @change="toggle(item)"
        ></v-switch>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
              >edit</v-icon
            >
          </v-avatar>
        </div>
        <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
      </template>
      <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Visit Type",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    visit_type_super_master_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      name: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Visit Type" : "Edit Visit Type";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.name = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Admin/adminVisitTypeSuperMaster")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.visit_type_super_master_list =
                res.data.visit_type_super_master_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.visit_type_super_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Admin/editAdminVisitTypeSuperMaster", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.visit_type_super_master_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Visit Type Updated Successfully..."
                ); // show snackbar on success
              } else {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        axios
          .post("/Admin/saveAdminVisitTypeSuperMaster", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              //   this.visit_type_super_master_list.push(this.editedItem);
              this.showSnackbar("#4caf50", "Visit Type Added Successfully..."); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Visit Type Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, // end of save()
    toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/Admin/toggleVisitTypeSuperMaster", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Visit Type Status Changed!"); // show snackbar
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#b71c1c",
              "Something went wrong, Please try again later!"
            ); // show snackbar
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    isValidated() {
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>